export default __webpack_public_path__ + "static/media/menu-doc-active.1c3060ae.svg";